// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getEnvVar = (key: string, enviroment: any, optional?: boolean) => {
  if (!optional && enviroment[key] === undefined) {
    throw new Error(`Env variable ${key} is required`)
  }

  return enviroment[key]
}
